<div class="faq-window">
  <div class="faq-window__header">
    <span class="faq-window__title-text">{{ 'help-faq.WINDOW_TITLE' | translate }}</span>
    <button class="faq-window__close" (click)="closed.emit()" [attr.aria-label]="'help-faq.CLOSE' | translate">
      <nova-icon name="close" aria-hidden="true"></nova-icon>
    </button>
  </div>

  <ul class="faq-window__list">
    @for (item of items(); track item.title; let i = $index) {
      <li class="faq-window__item">
        <button
          class="faq-window__item-header"
          [class.faq-window__item-header_expanded]="isExpanded(i)"
          [attr.aria-expanded]="isExpanded(i)"
          (click)="toggle(item, i)"
        >
          <span class="faq-window__item-title">{{ resolveLabel(item) | translate }}</span>
          <nova-icon
            name="expand_more"
            class="faq-window__chevron"
            [class.faq-window__chevron--expanded]="isExpanded(i)"
            aria-hidden="true"
          ></nova-icon>
        </button>
        <section
          class="faq-window__panel"
          [class.faq-window__panel--expanded]="isExpanded(i)"
        >
          <div class="faq-window__panel-inner">
            @if (isLoading(i)) {
              <div class="faq-window__loading" [attr.aria-label]="'help-faq.LOADING' | translate">
                <span class="faq-window__spinner"></span>
              </div>
            } @else {
              <app-faq-qa-list
                [items]="getQuestions(i)"
              ></app-faq-qa-list>
            }
          </div>
        </section>
      </li>
    }
  </ul>
</div>
